import { useTheme } from '@mui/material';

export const PatientChartIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
    } = theme.colors.other.icon;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} fill="none">
            <path
                fill={primaryStroke}
                d="M34 38H14V10h10v10h10v18Zm-8-27.669L33.669 18H26v-7.669ZM26.5 8H12v32h24V17.5L26.5 8ZM19 24h-1v2h12v-2H19Zm0 4h-1v2h12v-2H19Zm0 4h-1v2h12v-2H19Z"
            />
        </svg>
    );
};
